module.exports = __webpack_public_path__ + "static/img/code.563c152.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/code.png
// module id = OwHf
// module chunks = 12